import PriceInfo from './PriceInfo'

export * from './PriceInfo'

export default PriceInfo
